const WIDERRUF_TICKET_PATH = '/support/tickets/new?ticket_form=widerruf';

function getContractRevocationUrl(faqUrl: string): string {
    const base = faqUrl.replace(/\/$/, '');
    return `${base}${WIDERRUF_TICKET_PATH}`;
}

export { getContractRevocationUrl, WIDERRUF_TICKET_PATH };
